import { defineStore, IStoreState } from "@/utils/store"

const user = defineStore({
  state: {
    uid: '',
    phone: '',
    maskedPhone: '',
    token: '',
    cfrnid: '',
    ruid: '',
    marketFreeLogin: false, // 外投免登，如果免登的话需要额外帮注册协议
    // WhatsApp 静默登录状态
    silentLoginType: '', // 静默登录类型 'whatsapp' | ''
    isSilentLogin: false, // 是否静默登录成功
  },
  mutations: {
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default user
export type IUserStoreState = IStoreState<typeof user.state>
